import { render, staticRenderFns } from "./VideoCallDireto.vue?vue&type=template&id=3e56692b&"
import script from "./VideoCallDireto.vue?vue&type=script&lang=js&"
export * from "./VideoCallDireto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports